export default __webpack_public_path__ + "static/media/good-5.d46f612f.png";